import { Button } from '@/components/ui/button';
import { ArrowRight, Zap } from 'lucide-react';
import { Link } from 'wouter';

const CTA = () => {
  return (
    <section className="py-24 bg-gradient-to-r from-cyan-500 via-teal-500 to-emerald-500 relative overflow-hidden">
      {/* Enhanced background decorations */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Large floating gradients */}
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-white/20 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-white/15 rounded-full blur-3xl"></div>
        
        {/* Medium orbs */}
        <div className="absolute top-20 left-1/4 w-40 h-40 bg-white/10 rounded-full blur-2xl"></div>
        <div className="absolute bottom-20 right-1/3 w-32 h-32 bg-white/20 rounded-full blur-2xl"></div>
        
        {/* Animated mesh gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-cyan-400/30 via-transparent to-teal-600/30"></div>
        
        {/* Rotating gradient rings */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] border border-white/10 rounded-full"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] border border-white/5 rounded-full"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center text-white">
          {/* Floating icon */}
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 rounded-full mb-6">
            <Zap className="w-8 h-8 text-white" />
          </div>

          <h2 className="text-4xl md:text-6xl font-bold mb-8">
            <span className="bg-gradient-to-r from-yellow-300 via-yellow-400 to-yellow-500 bg-clip-text text-transparent">
              Don't waste more time
            </span>
          </h2>
          
          <p className="text-xl md:text-2xl mb-10 opacity-90 leading-relaxed max-w-3xl mx-auto">
            Join coaches across the country who are saving time and making better recruitment decisions with Bloom.
          </p>
          
          <div className="flex justify-center items-center mb-12">
            <Link href="/register">
              <Button 
                size="lg" 
                className="relative bg-white text-cyan-600 hover:text-cyan-700 px-12 py-6 text-xl font-semibold shadow-2xl transition-all duration-500 transform hover:scale-110 hover:-translate-y-2 group overflow-hidden"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-cyan-50 to-teal-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <span className="relative z-10">Create Your Account</span>
                <ArrowRight className="ml-3 w-6 h-6 relative z-10 group-hover:translate-x-1 transition-transform duration-300" />
              </Button>
            </Link>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CTA; 